import { tween, styler, easing } from 'popmotion'
import baseMixin from './baseMixin'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'internal-data-graphic'
    },

    methods: {
        setStyler() {
            this.styler = styler(this.baseElement.querySelector('#full'))
        },

        initAction() {
            return tween({
                from: { opacity: 1 },
                to: { opacity: 0 },
                ease: easing.linear,
                duration: 300
            })
        },

        initReaction(v) {
            this.styler.set(v)
        },

        animationAction() {
            return tween({
                from: { opacity: 0 },
                to: { opacity: 1 },
                ease: easing.linear,
                duration: 2000
            })
        },

        animationReaction(v) {
            this.styler.set(v)
        }
    }
}
